import AlertPlugin from './alert';
import ConfirmPlugin from './confirm';
import PromptPlugin from './prompt';

export { AlertPlugin, ConfirmPlugin, PromptPlugin };



// WEBPACK FOOTER //
// ./src/plugins/dialog/index.js